(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/redux-store.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/redux-store.js');
"use strict";


const pagesReducer = svs.tickets_giftshop.pages.reducer;
const giftformReducer = svs.tickets_giftshop.gift.giftform.reducer;
const cartReducer = svs.tickets_giftshop.gift.giftform.cart.reducer;
const productsReducer = svs.tickets_giftshop.products.reducer;
const packs = svs.tickets_giftshop.data.moduleConfig.packs || [];
const combinedReducers = RTK.combineReducers({
  giftform: giftformReducer,
  cart: cartReducer,
  products: productsReducer,
  settings: pagesReducer
});
const reduxLocalStorage = svs.app.ReduxLocalStorage({
  domain: svs.tickets_giftshop.constants.cache.DOMAIN,
  key: svs.tickets_giftshop.constants.cache.KEY,
  expires: svs.components.Storage.constants.EXPIRES_15M,
  debounce: 500,
  states: ['cart', 'giftform']
});
const configName = svs.utils.paramHandler.get({
  key: 'paket'
}).value;
svs.utils.paramHandler.remove({
  key: 'paket'
});
const config = packs.find(pack => {
  var _pack$title;
  return ((_pack$title = pack.title) === null || _pack$title === void 0 ? void 0 : _pack$title.toLowerCase()) === (configName === null || configName === void 0 ? void 0 : configName.toLowerCase());
});
let parsedConfig;
if (config) {
  parsedConfig = JSON.parse(config.configBase64);
}
const middlewares = RTK.applyMiddleware(reduxLocalStorage.middleware());
const composed = RTK.compose(middlewares);
const store = RTK.createStore(combinedReducers, parsedConfig || reduxLocalStorage.load(), composed);

store.dispatch({
  type: 'noop'
});
svs.tickets_giftshop.clearLocalStorage = () => {
  reduxLocalStorage.clear();
};
svs.tickets_giftshop.createstore = withMiddlewares => {
  if (withMiddlewares) {
    return RTK.createStore(combinedReducers, reduxLocalStorage.load(), composed);
  }
  return RTK.createStore(combinedReducers);
};
svs.tickets_giftshop.store = store;

if (svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL)) {
  const saveConfig = () => {
    navigator.clipboard.writeText(JSON.stringify(reduxLocalStorage.load()));
  };
  const btn = document.createElement('button');
  btn.innerText = 'Kopiera config';
  btn.addEventListener('click', saveConfig);
  document.querySelector('#top-content').appendChild(btn);
}

 })(window);